/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  getBytesEncoder,
  getProgramDerivedAddress,
  type Address,
  type ProgramDerivedAddress,
} from "@solana/kit";

export async function findConfigPda(
  config: { programAddress?: Address | undefined } = {},
): Promise<ProgramDerivedAddress> {
  const {
    programAddress = "D4Dq6ce6PwK7x51RpG5PVQkX3jD3pcteoEWR5LeSM7UQ" as Address<"D4Dq6ce6PwK7x51RpG5PVQkX3jD3pcteoEWR5LeSM7UQ">,
  } = config;
  return await getProgramDerivedAddress({
    programAddress,
    seeds: [
      getBytesEncoder().encode(new Uint8Array([99, 111, 110, 102, 105, 103])),
    ],
  });
}
